import React from "react";
import { chatConfig } from "../../../config/chatConfig";
import '../../../Styles/Space/Space Page/KnowledgeTracker.css';
interface KnowledgeTrackerProps {
  knowledgeCount: number;
}

const KnowledgeTracker: React.FC<KnowledgeTrackerProps> = ({
  knowledgeCount,
}) => {
  const knowledgePercentage = Math.min((knowledgeCount || 0) / chatConfig.limits.tokens.MAX_SPACE_ATTACHMENTS_TOKENS * 100, 100);
  const isFull = knowledgePercentage >= 100;

  return (
    <div className="knowledge-tracker">
      <div className="knowledge-tracker-header">
        <span>Knowledge Capacity</span>
        <span>
          {Math.round(knowledgePercentage)}%
          {isFull && " (Full)"}
        </span>
      </div>
      <div className="knowledge-tracker-bar">
        <div
          className={`knowledge-tracker-progress${isFull ? " full" : ""}`}
          style={{ width: `${knowledgePercentage}%` }}
        />
      </div>
    </div>
  );
};

export default KnowledgeTracker;
